module.exports = __webpack_public_path__ + "img/广告图五.4e8ed346.jpg";